var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 12.9166C16.6674 12.6946 16.7269 12.4767 16.8395 12.2853C16.952 12.0939 17.1135 11.936 17.3073 11.8277C17.5012 11.7194 17.7203 11.6647 17.9423 11.6692C18.1643 11.6737 18.381 11.7372 18.5703 11.8533L24.677 15.6016C24.859 15.7134 25.0093 15.8701 25.1136 16.0565C25.2178 16.2429 25.2726 16.453 25.2726 16.6666C25.2726 16.8802 25.2178 17.0903 25.1136 17.2767C25.0093 17.4632 24.859 17.6198 24.677 17.7316L18.5703 21.4816C18.3808 21.5978 18.1637 21.6613 17.9415 21.6657C17.7192 21.6701 17.4998 21.6151 17.3059 21.5064C17.112 21.3977 16.9505 21.2393 16.8382 21.0474C16.7259 20.8556 16.6668 20.6372 16.667 20.4149V12.9166Z",
    stroke: "#17181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 35H28.3337",
    stroke: "#17181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 5H6.66634C4.82539 5 3.33301 6.49238 3.33301 8.33333V25C3.33301 26.841 4.82539 28.3333 6.66634 28.3333H33.333C35.174 28.3333 36.6663 26.841 36.6663 25V8.33333C36.6663 6.49238 35.174 5 33.333 5Z",
    stroke: "#17181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.5a0050486ca770cb207038ade3707913.svg";
export { ForwardRef as ReactComponent };